import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import { createPortal } from "react-dom";

export function DropdownPortal({ anchorEl, open, onClose, children, offsetY = 8 }) {
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  const menuRef = useRef(null);

  useLayoutEffect(() => {
    if (!open || !anchorEl) return;
    const rect = anchorEl.getBoundingClientRect();
    setPos({ top: rect.bottom + offsetY, left: rect.right, width: rect.width });
  }, [open, anchorEl, offsetY]);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target) && anchorEl && !anchorEl.contains(e.target)) onClose?.();
    };
    const onScrollOrResize = () => onClose?.();
    document.addEventListener("mousedown", onClick);
    window.addEventListener("scroll", onScrollOrResize, true);
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      document.removeEventListener("mousedown", onClick);
      window.removeEventListener("scroll", onScrollOrResize, true);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [open, anchorEl, onClose]);

  if (!open) return null;
  return createPortal(
    <div
      ref={menuRef}
      style={{ position: "fixed", top: pos.top, left: pos.left, transform: "translateX(-100%)", zIndex: 10000 }}
      className="rounded-xl shadow-lg bg-white ring-1 ring-black/10 min-w-[12rem] overflow-hidden"
    >
      {children}
    </div>,
    document.body
  );
}
